"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagsPlugin = void 0;
const feature_flag_1 = __importDefault(require("../components/feature-flag"));
exports.FeatureFlagsPlugin = {
    async install(Vue) {
        Vue.component('feature-flag', feature_flag_1.default);
    }
};
